<template>
    <Head :title="item.name" />

    <FrontLayout>
        <div class="grid grid-cols-1 lg:grid-cols-5 gap-10">
            <div class="space-y-4 lg:col-span-2">
                <div class="bg-white rounded-2xl border overflow-hidden aspect-square">
                    <img v-if="item.media?.length" :src="activeImage"
                        class="w-full h-full object-cover"
                    >
                    <div v-else class="flex items-center justify-center h-full text-gray-400">
                        <i class="fas fa-image text-7xl"></i>
                    </div>
                </div>

                <div class="flex gap-3 p-1 overflow-x-auto no-scrollbar">
                    <div v-for="media in item.media" :key="media.id" @click="activeImage = media.original_url"
                        class="w-20 h-20 flex-shrink-0 border rounded-xl overflow-hidden cursor-pointer hover:opacity-80"
                        :class="activeImage === media.original_url ? 'ring-2 ring-primaryOrange' : ''"
                    >
                        <img :src="media.original_url" class="w-full h-full object-cover">
                    </div>
                </div>
            </div>

            <div class="lg:col-span-3">
                <h1 class="text-3xl font-bold text-gray-800">{{ item.name }}</h1>

                <p class="text-gray-400 my-2 space-x-2">
                    <span v-for="cat in item.categories" :key="cat.id" class="px-2 py-1 text-sm bg-primaryOrange text-white rounded-sm">
                        {{ cat.name }}
                    </span>
                </p>

                <!-- <div class="text-4xl font-bold text-primaryOrange mt-4">{{ formatAmount(item.price, currency) }}</div> -->

                <div class="text-gray-700 leading-relaxed mt-2 text-sm">
                    <div v-html="item.description"></div>
                </div>

                <div class="mt-8">
                    <a :href="whatsappLink(item)" target="_blank"
                        class="w-full flex justify-center items-center gap-2 bg-green-600 hover:bg-green-700 text-white py-4 rounded-xl text-lg font-semibold transition"
                    ><i class="fab fa-whatsapp text-xl"></i> Commander sur WhatsApp
                    </a>

                    <p class="text-xs text-gray-400 text-center mt-2">
                        Réponse rapide via WhatsApp Business
                    </p>
                </div>
            </div>
        </div>

        <div class="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            <div class="bg-white border rounded-2xl p-6">
                <h3 class="font-bold text-gray-800 mb-2">Livraison</h3>
                <p class="text-sm text-gray-600">
                    Nous assurons l'expédition rapide et sécurisée depuis le Royaume Uni vers la Côte d'Ivoire.
                </p>
            </div>

            <div class="bg-white border rounded-2xl p-6">
                <h3 class="font-bold text-gray-800 mb-2">Sécurité</h3>
                <p class="text-sm text-gray-600">
                    Vos colis sont suivis et protégés durant tout le transport.
                </p>
            </div>

            <div class="bg-white border rounded-2xl p-6">
                <h3 class="font-bold text-gray-800 mb-2">Support</h3>
                <p class="text-sm text-gray-600">
                    Assistance client disponible via WhatsApp.
                </p>
            </div>
        </div>
    </FrontLayout>
</template>

<script>
    import { Head } from '@inertiajs/inertia-vue3'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import CurrencyMixins from '@/Mixins/CurrencyMixins'

    export default {
        components: {
            Head,
            FrontLayout
        },

        mixins: [CurrencyMixins],

        props: {
            item: Object,
            currency: Object
        },

        data() {
            return {
                activeImage: null
            }
        },

        mounted() {
            if (this.item.media?.length) {
                this.activeImage = this.item.media[0].original_url
            }
        },

        methods: {
            whatsappLink(item) {
                return route('track.whatsapp', item)
            }
        }
    }
</script>

<style scoped>
    .no-scrollbar::-webkit-scrollbar {
        display: none;
    }

    .no-scrollbar {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
</style>
